import { render, staticRenderFns } from "./SchoolDistrictSelection.vue?vue&type=template&id=2b7a538d"
import script from "./SchoolDistrictSelection.vue?vue&type=script&lang=js"
export * from "./SchoolDistrictSelection.vue?vue&type=script&lang=js"
import style0 from "./SchoolDistrictSelection.vue?vue&type=style&index=0&id=2b7a538d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports